import { useState } from 'react';
import { TaskType } from '../../../../store/api/tasks-api';
import { useDebounce } from 'use-debounce';

export const useMaxTime = () => {
  const [maxTime, setMaxTime] = useState(0);
  const uselessTasks: TaskType[] = [];

  const [debouncedMaxTime] = useDebounce(maxTime, 500);

  return {
    maxTime,
    onChangeMaxTime: setMaxTime,
    uselessTasks,
    debouncedMaxTime,
  };
};
